export const SpatialSearch=[
    {
        id: '北京数据中心',
        label: '北京数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: '北京',
        scaneName: '北京',
        highLight: '北京',
        num: 2,
        objType: 'space',
        components: 'ShuJuZhongXingSheng',
        level: '2',
        children: [
          {
            id: '分数据中心-01',
            label: '分数据中心-01',
            isSelect: false,
            type: '园区',
            spaceLevel: '园区',
            scaneName: '园区',
            highLight: '园区',
            num: 1,
            objType: 'space',
            components: 'ShuJuZhongXingYuanQu',
            level: '3',
            children: [
              {
                id: 'SM_IDC机房楼',
                label: 'IDC机房楼',
                isSelect: false,
                type: '建筑',
                spaceLevel: '',
                scaneName: '园区',
                num: 3,
                objType: 'space',
                components: 'JianZhu',
                level: '4',
                children: [
                  {
                    id: 'SM_IDC室内04',
                    label: 'F3',
                    isSelect: false,
                    type: '楼层',
                    spaceLevel: '楼层',
                    scaneName: '园区',
                    highLight: '楼层',
                    num: 3,
                    objType: 'space',
                    components: 'LouCeng',
                    level: '5',
                    children: [
                      {
                        id: '机柜组机房',
                        label: '机柜组机房',
                        isSelect: false,
                        type: '房间',
                        spaceLevel: '房间',
                        highLight: '机柜组机房',
                        scaneName: '园区',
                        num: 23,
                        objType: 'space',
                        components: 'FangJian',
                        level: '6',
                        children: [
                          {
                            id: 'C03-004_SM_机柜组',
                            label: 'C03-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 1,
                            objType: 'space',
                            components: 'JiGuiZaixian',
                            level: '7',
                            children: [
                              {
                                id: 'C03-004-04_SM_设备机柜',
                                label: 'C03-004-04_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: 'C03-004-04_SM_设备机柜',
                                num: 7,
                                objType: 'space',
                                components: 'JiGuiLixian',
                                level: '8',
                                children: [],
                              },
                              {
                                id: 'C03-005-04_SM_设备机柜',
                                label: 'C03-005-04_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: 'C03-005-04_SM_设备机柜',
                                num: 7,
                                objType: 'space',
                                components: 'JiGuiLixian',
                                level: '8',
                                children: [],
                              },
                              {
                                id: 'C03-006-04_SM_设备机柜',
                                label: 'C03-006-04_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: 'C03-004-06_SM_设备机柜',
                                num: 7,
                                objType: 'space',
                                components: 'JiGuiLixian',
                                level: '8',
                                children: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
]